import { render, staticRenderFns } from "./AppLabelColorSelector.vue?vue&type=template&id=f42973a6&scoped=true&"
import script from "./AppLabelColorSelector.vue?vue&type=script&lang=ts&"
export * from "./AppLabelColorSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppLabelColorSelector.vue?vue&type=style&index=0&id=f42973a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42973a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VColorPicker,VImg,VTextField})
